var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 250C500 271.262 482.776 288.474 461.538 288.474H288.462V461.551C288.462 482.813 271.238 500 250 500C228.762 500 211.538 482.813 211.538 461.551V288.474H38.4615C17.2236 288.474 0 271.262 0 250C0 228.738 17.2236 211.55 38.4615 211.55H211.538V38.4736C211.538 17.2115 228.762 0 250 0C271.238 0 288.462 17.2115 288.462 38.4736V211.55H461.538C482.813 211.538 500 228.726 500 250Z",
    fill: "#008393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c504cd3e8c23b5d20723b1f64b47350e.svg";
export { ForwardRef as ReactComponent };